import { useTranslation } from "react-i18next";
import "./NoResultsChart.scss";
import { BasicIcon, ToolTipPosition, Tooltip } from "@pickit/pickit-components";

const NoResultsChart = ({ chart }: { chart: "saturation" | "capacity" }) => {
  const { t } = useTranslation("dashboard");
  const charts = {
    saturation: {
      title: t("saturationTitle"),
      tooltip: t("saturationTooltip"),
      tooltipClass: "saturation-tooltip",
    },
    capacity: {
      title: t("slotCapacityTitle"),
      tooltip: t("slotCapacityTooltip"),
      tooltipClass: "capacity-tooltip",
    },
  };

  return (
    <div className="no-results-container">
      <div className="no-results-title">
        <h3>{charts[chart].title}</h3>
        <div className={charts[chart].tooltipClass}>
          <Tooltip
            message={charts[chart].tooltip}
            position={ToolTipPosition.top}
          >
            <BasicIcon
              name="information-circle"
              size="extra-small"
              color="#0098ff"
            />
          </Tooltip>
        </div>
      </div>
      <div className="empty-bar bar-1" />
      <div className="empty-bar bar-2">{t("noResults")}</div>
      <div className="empty-bar bar-3" />
      <div className="empty-bar bar-4" />
    </div>
  );
};

export default NoResultsChart;
